import React, { useState } from 'react'
import { IconButton, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useVideoThumbnail } from '../Utils/VideoUtils'

interface ThumbnailWithPlayButtonProps {
  socialThumbnailUrl?: string
  thumbnailUrl?: string
  handleStart: () => void
  playButtonText?: string
  contentCardPlayButtonText?: string
  contentCardSocialUrl?: string
}

const ThumbnailWithPlayButton: React.FC<ThumbnailWithPlayButtonProps> = ({
  socialThumbnailUrl,
  thumbnailUrl,
  handleStart,
  playButtonText,
  contentCardPlayButtonText,
  contentCardSocialUrl
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const classes = useStyles()

  const thumbnail = useVideoThumbnail(
    contentCardSocialUrl ?? '',
    thumbnailUrl ?? '',
    socialThumbnailUrl ?? ''
  )

  return (
    <div className={classes.overlay}>
      <img
        src={thumbnail}
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          maxWidth: '100%',
          marginLeft: 'unset'
        }}
      />
      <IconButton
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={classes.playButton}
        onClick={handleStart}
      >
        <Typography
          style={{
            margin: 'unset',
            color: isHovered ? '#000000' : '#ffffff',
            fontSize: '16px'
          }}
        >
          {playButtonText || contentCardPlayButtonText}
        </Typography>
      </IconButton>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  overlay: {
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      background: 'rgba(0, 0, 0, 0.5)'
    }
  },
  playButton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '27px 24px 28px 24px',
    width: '79px',
    height: '79px',
    borderRadius: '100px',
    background: 'rgba(255, 255, 255, 0.30)',
    zIndex: 1,
    '&:hover': {
      background: '#ffffff'
    }
  }
}))

export default ThumbnailWithPlayButton
